<div class="container-fluid">
    <h1 class="m-3 display-6 vm-container-header"><i class="bi bi-file-text me-2"></i>Extracts</h1>

    <div class="m-3 p-2 bg-body-light rounded-3 shadow">
        <div class="m-2">
            <form>
                <div class="mb-3 row align-items-center">
                    <div class="col-sm-auto">
                        <select (change)="this.onCustomerChange($event)" aria-label="Select a customer" class="form-select">
                            <option selected value="">Select a Customer</option>
                            @for (entity of this.customers; track entity.id; ) {
                                <option value="{{ entity.code }}">{{ entity.name }} [{{ entity.code }}]</option>
                            }
                        </select>
                    </div>

                    <div class="input-group col-sm-auto">
                        <span class="input-group-text" id="search-addon"><i class="bi bi-search"></i></span>
                        <input [(ngModel)]="this.extractsService.searchTerm" class="form-control shadow-none" id="table-complete-search" name="searchTerm"
                            type="text" placeholder="Search" aria-label="Search" aria-describedby="search-addon"/>
                    </div>

                    @if (!!this.customerCode) {
                        <div class="col-sm-auto" role="group">
                            <i class="btn btn-outline-primary bi bi-repeat" (click)="onRegenerateExtract()" title="Regenerate Extract"> Regenerate</i>
                        </div>
                    }
                </div>
            </form>

            @if (!!this.customerCode && ((this.extractsService.total$ | async) ?? 0) > 0) {
                <table class="table table-striped table-hover">
                    <caption>
                        <div class="container-fluid w-100">
                            <div class="row justify-content-center align-self-center">
                                <div class="col align-self-center">
                                    {{ this.extractsService.total$ | async }} Total
                                </div>
                            </div>
                        </div>
                    </caption>

                    <thead>
                    <tr>
                        <th (sort)="this.onSort($event)" scope="col" sortable="prefix">Customer</th>
                        <th (sort)="this.onSort($event)" scope="col" sortable="key">File</th>
                        <th (sort)="this.onSort($event)" scope="col" sortable="size" class="text-end">Size</th>
                        <th (sort)="this.onSort($event)" scope="col" sortable="lastModified">Last Modified</th>
                        <th scope="col" class="text-center">Actions</th>
                    </tr>
                    </thead>

                    <tbody class="table-group-divider">
                        @for (element of this.extractsService.data$ | async; track element.fileName; ) {
                            <tr class="align-middle">
                                <td>{{ this.customerCode }}</td>
                                <td class="text-ellipsis" title="{{ element.fileName }}" style="max-width: 25em;">{{ element.fileName }}
                                </td>
                                <td class="text-end">{{ filesize(element.size) }}</td>
                                <td>{{ this.formatDate(element.lastModified, "yyyy-MM-dd, hh:mm:ss a", "en-US") }}</td>
                                <td class="text-center">
                                    @if (this.showDownloadButton(element.fileName)) {
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-primary me-2"
                                            (click)="this.onDownloadFile(element.key, element.versionId)">
                                            <i class="bi bi-download"></i>
                                        </button>
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            }

            @if (!!this.customerCode && ((this.extractsService.total$ | async) ?? 0) > 0) {
                <app-table-pager [total]="(this.extractsService.total$ | async)!" [(page)]="this.extractsService.page" [(pageSize)]="this.extractsService.pageSize" />
            }

            @if (!this.customerCode) {
                <div class="card text-center bg-info-subtle border border-info rounded p-3 m-5">
                    <div class="card-body">
                        <i class="bi bi-info-circle-fill me-2"></i>Select a customer to see its extracts.
                    </div>
                </div>
            }

            @if (!!this.customerCode && ((this.extractsService.total$ | async) ?? 0) == 0 && !(this.globalService.waitOverlayIsVisible$ | async)) {
                <div class="card text-center bg-warning-subtle border border-warning rounded p-3 m-5">
                    <div class="card-body">
                        <i class="bi bi-exclamation-triangle-fill me-2"></i>No extracts found.
                    </div>
                </div>
            }
        </div>
    </div>

    <ng-template #regenerateExtractModal>
        <div class="modal-header">
            <h1 class="modal-title fs-5" id="editModalLabel">
                Regenerate Extract
            </h1>
            <button (click)="onRegenerateExtractDismiss()" type="button" class="btn-close" aria-label="Close"></button>
        </div>

        <form [formGroup]="regenerateExtractForm" (ngSubmit)="onRegenerateExtractSubmit()">
            <div class="modal-body container-fluid">
                <div class="row g-0">
                    <div class="form-floating mt-3 vm-pe-1">
                        <select id="extractKeyControl" formControlName="extractKey" aria-label="Select an extract" class="form-select form-control">
                            <option selected disabled value="">Select an Extract</option>
                            @for (extractKey of this.extractKeys; track extractKey; ) {
                                <option value="{{ extractKey }}">{{ extractKey }}</option>
                            }
                        </select>

                        <label for="extractKeyControl" class="form-label">Extract Key</label>
                    </div>

                    <div class="input-group">
                        <div class="form-floating mt-3 vm-pe-1">
                            <input
                                class="form-control"
                                placeholder="yyyy-mm-dd"
                                [maxDate]="today"
                                name="startDate"
                                formControlName="startDate"
                                id="extractStartDateControl"
                                ngbDatepicker
                                #startDate="ngbDatepicker"/>
                            <label for="extractStartDateControl" class="form-label">Start Date</label>
                        </div>
                        <span class="input-group-text bi bi-calendar3 mt-3" (click)="startDate.toggle()"></span>
                    </div>

                    <div class="input-group">
                        <div class="form-floating mt-3 vm-pe-1">
                            <input
                                class="form-control"
                                placeholder="yyyy-mm-dd"
                                [defaultValue]="today"
                                [maxDate]="today"
                                name="endDate"
                                formControlName="endDate"
                                id="extractEndDateControl"
                                ngbDatepicker
                                #endDate="ngbDatepicker"/>
                            <label for="extractEndDateControl" class="form-label">End Date</label>
                        </div>
                        <span class="input-group-text bi bi-calendar3 mt-3" (click)="endDate.toggle()"></span>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button type="submit" class="btn btn-primary" [disabled]="savingData">
                    @if (savingData) {
                        <span class="spinner-border spinner-border-sm me-1"></span>
                    }
                    Save
                </button>
                <button (click)="onRegenerateExtractDismiss()" type="button" class="btn btn-secondary">Close</button>
            </div>
        </form>
    </ng-template>

    <app-modal-confirm #confirmationModal></app-modal-confirm>
</div>
